import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAppSelector } from 'app/hooks';
import { selectDataLoading } from 'features/core/selectors';

interface Props {
  children: React.ReactNode;
}

const ScrollToTop = ({ children }: Props) => {
  const location = useLocation();
  const isDataLoading = useAppSelector(selectDataLoading);

  useEffect(() => {
    window.scrollTo(0,0);
  }, [location, isDataLoading]);

  return (
    <>{children}</>
  )

}

export default ScrollToTop;
